import { createFileRoute } from "@tanstack/react-router";

import SavedPage from "@/app/design-system/saved/SavedPage";

export const Route = createFileRoute("/admin/design-system/saved")({
  component: SavedPage,
});
